import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/projects/michelin-hp/node_modules/@babel/runtime/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
import getCookies from 'boot/cookies.js';
export function login(_x, _x2) {
  return _login.apply(this, arguments);
}

function _login() {
  _login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx, data) {
    var response, cookies, options;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axiosInstance({
              url: 'auth/token',
              method: 'post',
              data: data
            });

          case 3:
            response = _context.sent;
            cookies = getCookies();
            options = {
              secure: process.env.PROD,
              expires: parseInt(response.data.tokenLife) / 60 / 1000
            };
            cookies.set('auth_token', response.data.token, options);
            cookies.set('auth_token_life', response.data.tokenLife, options);
            cookies.set('auth_token_type', response.data.type, options);
            options.expires = parseInt(response.data.refreshTokenLife) / 60 / 1000;
            cookies.set('refresh_token', response.data.refreshToken, options);
            cookies.set('refresh_token_life', response.data.refreshTokenLife, options);
            ctx.commit('isAuthenticated', true);
            axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;
            return _context.abrupt("return", response);

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", _context.t0);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 17]]);
  }));
  return _login.apply(this, arguments);
}

export function logout(_x3, _x4) {
  return _logout.apply(this, arguments);
}

function _logout() {
  _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ctx, data) {
    var response, cookies;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return axiosInstance({
              url: 'auth/revoke',
              method: 'post',
              data: data
            });

          case 3:
            response = _context2.sent;
            cookies = getCookies();
            cookies.remove('auth_token');
            cookies.remove('auth_token_life');
            cookies.remove('auth_token_type');
            cookies.remove('refresh_token');
            cookies.remove('refresh_token_life');
            ctx.commit('isAuthenticated', false);
            ctx.commit('me', {});
            delete axiosInstance.defaults.headers.common['Authorization'];
            return _context2.abrupt("return", response);

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", _context2.t0);

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 16]]);
  }));
  return _logout.apply(this, arguments);
}

export function recoverPassword(_x5, _x6) {
  return _recoverPassword.apply(this, arguments);
}

function _recoverPassword() {
  _recoverPassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ctx, data) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return axiosInstance({
              url: 'auth/recover-password',
              method: 'post',
              data: data
            });

          case 3:
            ctx.commit('email', data.email);
            _context3.next = 9;
            break;

          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", _context3.t0);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 6]]);
  }));
  return _recoverPassword.apply(this, arguments);
}

export function codeVerify(_x7, _x8) {
  return _codeVerify.apply(this, arguments);
}

function _codeVerify() {
  _codeVerify = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(ctx, data) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            ctx.commit('code', data.verificationCode);
            _context4.prev = 1;
            _context4.next = 4;
            return axiosInstance({
              url: '/auth/verification-code/check',
              method: 'post',
              data: data
            });

          case 4:
            _context4.next = 9;
            break;

          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", _context4.t0);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 6]]);
  }));
  return _codeVerify.apply(this, arguments);
}

export function changePassword(_x9, _x10) {
  return _changePassword.apply(this, arguments);
}

function _changePassword() {
  _changePassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(ctx, data) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return axiosInstance({
              url: '/auth/reset-password',
              method: 'post',
              data: data
            });

          case 3:
            _context5.next = 8;
            break;

          case 5:
            _context5.prev = 5;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", _context5.t0);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 5]]);
  }));
  return _changePassword.apply(this, arguments);
}

export function me(_x11) {
  return _me.apply(this, arguments);
}

function _me() {
  _me = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(ctx) {
    var response;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return axiosInstance({
              url: '/auth/user',
              method: 'GET'
            });

          case 3:
            response = _context6.sent;
            ctx.commit('me', response.data);
            return _context6.abrupt("return", response);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", _context6.t0);

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));
  return _me.apply(this, arguments);
}

export function clear(ctx) {
  ctx.commit('isAuthenticated', false);
  var cookies = getCookies();
  cookies.remove('auth_token');
  cookies.remove('auth_token_life');
  cookies.remove('auth_token_type');
  cookies.remove('refresh_token');
  cookies.remove('refresh_token_life');
}